import { render, staticRenderFns } from "./FolImportacaoFuncao.vue?vue&type=template&id=57720c19&"
import script from "./FolImportacaoFuncao.vue?vue&type=script&lang=js&"
export * from "./FolImportacaoFuncao.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./FolImportacaoFuncao.vue?vue&type=style&index=1&id=57720c19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports